export default __webpack_public_path__ + "static/media/reportsIcon.6aae41aa.svg";